import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../../components/Common/TextFieldInput'
import ButtonInput from '../../components/Common/ButtonInput'
import {connect} from 'react-redux';
import {Modal} from '@material-ui/core';
import {checkAuth, getAuthToken} from '../../utils';
import MetaMaskPNG from '../../../public/img/download-metamask.png'
import './Wallets.scss';

const METAMASK_MODE = {
    NOT_INSTALLED: 0,
    NOT_LOGGED_ON: 1,
    LOGGED_ON: 2,
};

class Wallets extends Component {

    state = {
        mode: METAMASK_MODE.NOT_INSTALLED,
        companies: {},
        defaultCompanyId: -1,
        wallets: [{
            address: '',
            balance: '',
            currency: '',
        }],
        bitcoinWallets: [{
           address: '',
           balance: '',
           currency: '',
           enabled: true,
        }],
        isOpenModal: false
    };

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const web3 = window.web3 || window.parent.web3;
        let {mode, ethereumAddress, balance} = this.state;
        console.log(web3, 'web3');

        if (typeof web3 === 'undefined' ||
            typeof web3.currentProvider.isMetaMask === 'undefined' ||
            !web3.currentProvider.isMetaMask) {
            console.error('MetaMask is not installed')
        } else {
            console.log('Wallets is installed');

            web3.eth.getAccounts((err, accounts) => {
                console.log(err, accounts.length, 'accounts');
                if (accounts.length > 0) {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        this.setState({mode: METAMASK_MODE.LOGGED_ON})
                    });
                } else {
                    console.error('Wallets is installed, bot not logged on.');
                    this.setState({mode: METAMASK_MODE.NOT_LOGGED_ON});
                }
            });

            window.ethereum.on('networkChanged', (netId) => {
                console.log(netId, 'accountsChanged')
            });

            web3.currentProvider.publicConfigStore.on('update', (test) => {
                console.log(test, 'currentProvider update');
                web3.eth.getAccounts((err, accounts) => {
                    console.log(err, accounts.length, 'accounts update');
                    if (accounts.length > 0) {
                        web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                            this.setState({mode: METAMASK_MODE.LOGGED_ON})
                        });
                    } else {
                        console.error('Wallets is installed, bot not logged on.');
                        this.setState({mode: METAMASK_MODE.NOT_LOGGED_ON});
                    }
                });
            });

            window.ethereum.on('accountsChanged', (accounts) => {
                console.log(accounts, 'accountsChanged');

                if (accounts.length > 0 && typeof accounts[0] !== 'undefined') {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        this.setState({mode: METAMASK_MODE.LOGGED_ON})
                    });
                } else {
                    console.error('Wallets is installed, bot not logged on.');
                    this.setState({mode: METAMASK_MODE.NOT_LOGGED_ON})
                }
            });
        }

        // obtain antenna tone atom armor category develop charge motion lock stage airport
        const authToken = getAuthToken();

        Api.get(`company/current`, authToken)
            .then((response) => {
                console.log(response, 'response companies/current');
                if (response.data) {
                    //TODO Create normal modal window with list of users companies. Then choose company to which we save address.
                    this.setState({companies: response.data, defaultCompanyId: response.data[0].id});

                    Api.get(`company/user-companies-wallets`, authToken)
                        .then((response) => {
                            console.log(response, 'response companies wallets');
                            console.log(response.data);
                            let wallets = [];
                            let bitcoinWallets = [];
                            if (response.data.length > 0) {
                                for (const wallet of response.data) {
                                    if (wallet.currency === 'ETH') {
                                        wallets.push(wallet);
                                    } else {
                                        wallet.enabled = false;
                                        bitcoinWallets.push(wallet);
                                    }
                                }
                                bitcoinWallets.push({
                                    address: '',
                                    balance: '',
                                    currency: '',
                                    enabled: true,
                                });
                            } else {
                                wallets.push({
                                    address: '',
                                    balance: '',
                                    currency: '',
                                });
                                bitcoinWallets.push({
                                    address: '',
                                    balance: '',
                                    currency: '',
                                    enabled: true,
                                });
                            }

                            console.log(wallets, 'wallets');
                            console.log(bitcoinWallets, 'bitcoinWallets');

                            this.setState({wallets});
                            this.setState({bitcoinWallets});

                            setTimeout(() => this.props.handleLoader(false), 200)
                        }).catch((error) => {
                        checkAuth(error, this.props.history);
                    });
                } else {
                    alert('First of all add personal data');
                    this.props.history.push('/user/personal-data/info');
                    setTimeout(() => this.props.handleLoader(false), 200)
                }
            }).catch((error) => {
            checkAuth(error, this.props.history);
            // setTimeout(() => this.props.handleLoader(false), 200)
        });
    }


    render() {
        const {wallets, mode, isOpenModal, bitcoinWallets} = this.state;

        return (
            <div className='content-wrapper'>
                <div className="content">
                <div className="content-h2">Bitcoin</div>
                <div className="hr-content"/>
                <div className="content-body content-right">
                    {bitcoinWallets.length > 0 && this.state.bitcoinWallets.map((wallet, index) => {
                        return (
                            <div className="fields-row m-b-5" key={index}>
                                <TextFieldInput name='bitcoinAddress'
                                                id={'bitcoinAddress-' + index}
                                                label='Bitcoin Address'
                                                required={true}
                                                value={wallet.address}
                                                disabled={!wallet.enabled}
                                                classes='width-595'
                                                shrink={{
                                                    shrink: true
                                                }}
                                                handleChange={(e) => this.handleChangeBtc(e)}/>
                                <TextFieldInput name='balance'
                                                disabled={true}
                                                id={'balance-' + index}
                                                label='Balance'
                                                required={true}
                                                value={wallet.balance}
                                                shrink={{
                                                    shrink: true
                                                }}
                                                classes='width-271'
                                                handleChange={(e) => this.handleChange(e)}/>
                            </div>
                        )
                    })}
                    <div className="fields-row">
                        <ButtonInput
                            width='194'
                            className={`dark-button blue-button`}
                            title='Add wallet'
                            handleClick={(e) => this.onSubmitWalletBtc(e)}/>
                    </div>
                </div>
                </div>
                {/*{mode === METAMASK_MODE.LOGGED_ON ?*/}
                    {/*<div className="content">*/}
                        {/*<div className="content-h2">MetaMask</div>*/}
                        {/*<div className="hr-content"/>*/}
                        {/*<div className="content-body content-right">*/}
                            {/*{wallets.length > 0 && wallets.map((wallet, index) => {*/}
                                {/*return (*/}
                                    {/*<div className="fields-row m-b-5" key={index}>*/}
                                        {/*<TextFieldInput name='ethereumAddress'*/}
                                                        {/*id={'ethereumAddress-' + index}*/}
                                                        {/*label='Ethereum Address'*/}
                                                        {/*required={true}*/}
                                                        {/*value={wallet.address}*/}
                                                        {/*disabled={true}*/}
                                                        {/*classes='width-595'*/}
                                                        {/*shrink={{*/}
                                                            {/*shrink: true*/}
                                                        {/*}}*/}
                                                        {/*handleChange={(e) => this.handleChange(e)}/>*/}
                                        {/*<TextFieldInput name='balance'*/}
                                                        {/*disabled={true}*/}
                                                        {/*id={'balance-' + index}*/}
                                                        {/*label='Balance'*/}
                                                        {/*required={true}*/}
                                                        {/*value={wallet.balance}*/}
                                                        {/*shrink={{*/}
                                                            {/*shrink: true*/}
                                                        {/*}}*/}
                                                        {/*classes='width-271'*/}
                                                        {/*handleChange={(e) => this.handleChange(e)}/>*/}
                                    {/*</div>*/}
                                {/*)*/}
                            {/*})}*/}
                            {/*<div className="fields-row">*/}
                                {/*<span className="password-tip">By clicking the button below system will add your active account from Metamask to your profile and assign it to company that you have added during previous step.</span>*/}
                            {/*</div>*/}
                            {/*/!*<div className="fields-row">*!/*/}
                                {/*/!*<ButtonInput*!/*/}
                                    {/*/!*width='194'*!/*/}
                                    {/*/!*className={`dark-button blue-button`}*!/*/}
                                    {/*/!*title='Add wallet'*!/*/}
                                    {/*/!*handleClick={(e) => this.onSubmitWallet(e)}/>*!/*/}
                            {/*/!*</div>*!/*/}
                        {/*</div>*/}
                    {/*</div> : (mode === METAMASK_MODE.NOT_LOGGED_ON ?*/}
                            {/*<div className="content">*/}
                                {/*<div className="content-h2">We use MetaMask</div>*/}
                                {/*<div className="content-body content-right">*/}
                                    {/*<div className="content-desc">*/}
                                        {/*Looks like you have installed the Metamask plugin already. Please Log in into*/}
                                        {/*Metamask plugin, so we can get information about your wallet from there.*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                            {/*:*/}
                            {/*<div className="content">*/}
                                {/*<div className="content-h2">We use MetaMask</div>*/}
                                {/*<div className="content-body content-right">*/}
                                    {/*<div className="content-desc">*/}
                                        {/*MetaMask is a browser extension that allows you to access your wallet quickly,*/}
                                        {/*safely & easily. It is more secure because you never enter your private key on a*/}
                                        {/*website. It protects you from phishing & malicious websites. Currently, we*/}
                                        {/*support next versions of desktop browsers for Windows, macOS, and Linux: Chrome*/}
                                        {/*57 or later, Firefox 52 or later, Opera 44 or later.*/}
                                    {/*</div>*/}
                                    {/*<div className="fields-row">*/}
                                        {/*<a href="https://metamask.io" target='_blank'>*/}
                                            {/*<img src={MetaMaskPNG} alt="Install MetaMask"/>*/}
                                        {/*</a>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                    {/*)}*/}
            </div>
        )
    }

    onSubmitWalletBtc = () => {
        const lastIndex = this.state.bitcoinWallets.length - 1;
        const lastWallet = this.state.bitcoinWallets[lastIndex];
        if (lastWallet.address.length != 34) {
            alert('Incorrect wallet format');
            return;
        }
        if (lastWallet.balance === null || lastWallet.balance === '') {
            alert('Incorrect wallet format');
            return;
        }
        const data = {
            balance: lastWallet.balance,
            address: lastWallet.address,
            currency: 'BTC'
        };
        const authToken = getAuthToken();
        let {defaultCompanyId, companies} = this.state;
        console.log(companies, 'data companies');

        Api.post(`company/${defaultCompanyId}/wallets`, data, authToken).then((response) => {

            if (response.data.length > 0) {
                if (response.data.length > 0) {
                    let wallets = [];
                    let bitcoinWallets = [];
                    if (response.data.length > 0) {
                        for (const wallet of response.data) {
                            if (wallet.currency === 'ETH') {
                                wallets.push(wallet);
                            } else {
                                wallet.enabled = false;
                                bitcoinWallets.push(wallet);
                            }
                        }
                        bitcoinWallets.push({
                            address: '',
                            balance: '',
                            currency: '',
                            enabled: true,
                        });
                    } else {
                        wallets.push({
                            address: '',
                            balance: '',
                            currency: '',
                        });
                        bitcoinWallets.push({
                            address: '',
                            balance: '',
                            currency: '',
                            enabled: true,
                        });
                    }

                    this.setState({wallets});
                    this.setState({bitcoinWallets});
                }
            }

            setTimeout(() => this.props.handleLoader(false), 200)
        }).catch((error) => {
            setTimeout(() => this.props.handleLoader(false), 200);
            checkAuth(error, this.props.history);
            console.log(error.response);
            alert(error.response.data);
        });
    };

    onSubmitWallet = () => {
        const authToken = getAuthToken();

        const web3 = window.web3 || window.parent.web3;
        let {mode, defaultCompanyId, company: companies} = this.state;

        if (typeof web3 === 'undefined' ||
            typeof web3.currentProvider.isMetaMask === 'undefined' ||
            !web3.currentProvider.isMetaMask) {
            alert('MetaMask is not installed');
            return null;
        } else {
            web3.eth.getAccounts((err, accounts) => {
                console.log(err, accounts.length, 'accounts');
                if (accounts.length > 0) {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        this.props.handleLoader(true);

                        balanceWei = web3.fromWei(balanceWei, "ether").toString();
                        const balance = parseFloat(balanceWei);
                        const ethereumAddress = accounts[0];
                        mode = METAMASK_MODE.LOGGED_ON;

                        const data = {
                            balance: balance,
                            address: ethereumAddress,
                            currency: "ETH"
                        };

                        console.log(companies, 'data companies');

                        Api.post(`company/${defaultCompanyId}/wallets`, data, authToken).then((response) => {

                            console.log(response, 'response wallets');

                            if (response.data.length > 0) {
                                let wallets = [];
                                let bitcoinWallets = [];
                                if (response.data.length > 0) {
                                    for (const wallet of response.data) {
                                        if (wallet.currency === 'ETH') {
                                            wallets.push(wallet);
                                        } else {
                                            wallet.enabled = false;
                                            bitcoinWallets.push(wallet);
                                        }
                                    }
                                } else {
                                    wallets.push({
                                        address: '',
                                        balance: '',
                                        currency: '',
                                    });
                                    bitcoinWallets.push({
                                        address: '',
                                        balance: '',
                                        currency: '',
                                        enabled: true,
                                    });
                                }

                                this.setState({wallets});
                                this.setState({bitcoinWallets});
                            }

                            setTimeout(() => this.props.handleLoader(false), 200)
                        }).catch((error) => {
                            setTimeout(() => this.props.handleLoader(false), 200);
                            checkAuth(error, this.props.history);
                            console.log(error.response);
                            alert(error.response.data);
                        });
                    });

                } else {
                    mode = METAMASK_MODE.NOT_LOGGED_ON;
                    this.setState({mode});
                    alert('Wallets is installed, bot not logged on.');
                    return null;
                }
            });
        }

    };

    getWallet = () => {
        const web3 = window.web3 || window.parent.web3;
        let {mode, ethereumAddress, balance} = this.state;

        if (typeof web3 === 'undefined' ||
            typeof web3.currentProvider.isMetaMask === 'undefined' ||
            !web3.currentProvider.isMetaMask) {
            alert('MetaMask is not installed');
            return null;
        } else {
            web3.eth.getAccounts((err, accounts) => {
                console.log(err, accounts.length, 'accounts');
                if (accounts.length > 0) {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        balanceWei = web3.fromWei(balanceWei, "ether").toString();
                        balance = parseFloat(balanceWei);
                        ethereumAddress = accounts[0];
                        mode = METAMASK_MODE.LOGGED_ON;
                        console.log(balance, 'User balance');

                        return {balance: balance, ethereumAddress: ethereumAddress};
                    });

                } else {
                    mode = METAMASK_MODE.NOT_LOGGED_ON;
                    this.setState({mode});
                    alert('Wallets is installed, bot not logged on.');
                    return null;
                }
            });
        }
    };

    handleChange = event => {
        const {errors} = this.state;
        console.log(event.target.name, 'event.target.name');

        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    handleChangeBtc = event => {
        const from = 'bitcoinAddress-'.length;
        const walletIndex = +event.target.id.substring(from);
        this.state.bitcoinWallets[walletIndex].address = event.target.value.trim();
        this.setState({bitcoinWallets: this.state.bitcoinWallets});
        const address = this.state.bitcoinWallets[walletIndex].address;
        if (address.length === 34) {
            const target = event.target;
            Api.getBalanceBTC(address).then(response => {
                this.state.bitcoinWallets[walletIndex].balance = response.data.balance / 100000000;
                this.setState({bitcoinWallets: this.state.bitcoinWallets});
            }).catch((error) => {
                console.log(error);
                target.disabled = false;
                this.state.bitcoinWallets[walletIndex].address = '';
                this.state.bitcoinWallets[walletIndex].balance = '';
            })

        }
    };

    metamaskTreker = () => {

        const web3 = window.web3 || window.parent.web3;
        let {mode, ethereumAddress, balance} = this.state;
        console.log(web3, 'web3');

        if (typeof web3 === 'undefined' ||
            typeof web3.currentProvider.isMetaMask === 'undefined' ||
            !web3.currentProvider.isMetaMask) {
            console.error('MetaMask is not installed')
        } else {
            console.log('Wallets is installed');

            web3.eth.getAccounts((err, accounts) => {
                console.log(err, accounts.length, 'accounts');
                if (accounts.length > 0) {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        balanceWei = web3.fromWei(balanceWei, "ether").toString();
                        balance = parseFloat(balanceWei);
                        ethereumAddress = accounts[0];
                        mode = METAMASK_MODE.LOGGED_ON;
                        console.log(balance, 'User balance');

                        this.setState({mode, ethereumAddress, balance})
                    });

                } else {
                    mode = METAMASK_MODE.NOT_LOGGED_ON;
                    ethereumAddress = null;
                    balance = null;

                    this.setState({mode, ethereumAddress, balance});
                    console.error('Wallets is installed, bot not logged on.')
                }
            });

            window.ethereum.on('networkChanged', (netId) => {
                console.log(netId, 'accountsChanged');

                mode = METAMASK_MODE.NOT_LOGGED_ON;
                ethereumAddress = null;
                balance = null;
                this.setState({mode, ethereumAddress, balance})
            });

            web3.currentProvider.publicConfigStore.on('update', (test) => {
                console.log(test, '123');
                web3.eth.getAccounts((err, accounts) => {
                    console.log(err, accounts.length, 'accounts', 2222);
                    if (accounts.length > 0) {
                        web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                            balanceWei = web3.fromWei(balanceWei, "ether").toString();
                            balance = parseFloat(balanceWei);
                            ethereumAddress = accounts[0];
                            mode = METAMASK_MODE.LOGGED_ON;
                            console.log(balance, 'User balance');

                            this.setState({mode, ethereumAddress, balance})
                        });

                    } else {
                        mode = METAMASK_MODE.NOT_LOGGED_ON;
                        ethereumAddress = null;
                        balance = null;

                        this.setState({mode, ethereumAddress, balance});
                        console.error('Wallets is installed, bot not logged on.')
                    }
                });
            });

            this.setState({mode, ethereumAddress, balance});

            window.ethereum.on('accountsChanged', (accounts) => {
                console.log(accounts, 'accountsChanged', typeof accounts[0]);
                if (accounts.length > 0 && typeof accounts[0] !== 'undefined') {
                    web3.eth.getBalance(accounts[0], (err, balanceWei) => {
                        balanceWei = web3.fromWei(balanceWei, "ether").toString();
                        balance = parseFloat(balanceWei);
                        ethereumAddress = accounts[0];
                        mode = METAMASK_MODE.LOGGED_ON;
                        console.log(balance, 'User balance');

                        this.setState({mode, ethereumAddress, balance})
                    });
                } else {
                    mode = METAMASK_MODE.NOT_LOGGED_ON;
                    ethereumAddress = null;
                    balance = null;

                    this.setState({mode, ethereumAddress, balance});
                    console.error('Wallets is installed, bot not logged on.')
                }
            });
        }
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(Wallets);


// WEBPACK FOOTER //
// ./src/views/Wallets/Wallets.js